import UpcomingSessions from './UpcomingSessions.vue'

export default UpcomingSessions
